import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeOtherRemoveGql } from '../bimWorkOrderChangeOthersQueries';

export const useDeleteWorkOrderChangeOtherPrice = ({
    workOrderChangeId,
    checkedRows,
    onSuccess,
}: {
    workOrderChangeId: number;
    checkedRows: { workOrderChangeOtherPriceId: number; workOrderOtherPriceId: number | null }[];
    onSuccess: () => void;
}) => {
    const dispatch = useDispatch();

    const [deleteData, deleteStatus, deleteError, request, deleteSetData] = useRequest({
        requestId: 'deleteWorkOrderChangeOtherPrice',
        query: bimWorkOrderChangeOtherRemoveGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            workOrderChangeOtherPriceIds: checkedRows,
        }),
        [checkedRows, workOrderChangeId],
    );

    const deleteHandler = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    return {
        deleteData: deleteData?.bimRemoveWorkOrderChangeOthers,
        deleteStatus,
        deleteError,
        deleteSetData,
        deleteHandler,
    };
};
